import {
  type PermissionGroupQueries,
  defPermissionGroupQueries,
} from '@kizen/query/permission-group';
import AxiosService from '__services/AxiosService';

const queries: PermissionGroupQueries = defPermissionGroupQueries(AxiosService);

export const permissionGroupQuery: PermissionGroupQueries['permissionGroupQuery'] =
  queries.permissionGroupQuery;

export const permissionGroupsQuery: PermissionGroupQueries['permissionGroupsQuery'] =
  queries.permissionGroupsQuery;

export const permissionGroupHistoryQuery: PermissionGroupQueries['permissionGroupHistoryQuery'] =
  queries.permissionGroupHistoryQuery;

export const permissionGroupMetadataQuery: PermissionGroupQueries['permissionGroupMetadataQuery'] =
  queries.permissionGroupMetadataQuery;
